export default __webpack_public_path__ + "static/realWorldImg3-8e20ad0eaf54f600dc091f0c6392e75f.webp";